import { IUpdateNotificationSetting } from 'modules/settings/models';
import API from 'services/api';

export const updateNotificationSettingsRepresentative = ({
  payload,
}: {
  payload: IUpdateNotificationSetting;
}) => API.put('/api/notifications/permits-representative', payload);
